import { Pipe, PipeTransform } from '@angular/core';
import { parseApiDate } from '@shared/helpers/date-format.helper';

@Pipe({ name: 'dateFromNow', pure: true })

export class DateFromNowPipe implements PipeTransform {
  transform(value: string): string {
    const parsedDate = parseApiDate(value);
    return parsedDate ? parsedDate.fromNow() : '';
  }
}
